import { Link } from "react-router-dom";
import Logo from "../../../../assets/images/logo/logoText.png";

const MenuLogo = (props) => {
  return (
    <div className="hp-header-logo hp-d-flex hp-align-items-center">
      <Link
        to="/dashboard"
        className="hp-position-relative hp-d-flex"
        onClick={props.onClose}
        style={{
          transform: "translateX(0px) translateY(4px)",
        }}
      >
        <img
          className="hp-logo"
          src={Logo}
          alt="logo"
          style={{ backgroundColor: "transparent" }}
        />
      </Link>
    </div>
  );
};

export default MenuLogo;
